import { cva } from "cva";

export const expandingMenuContentStyles = cva({
  base: "overflow-hidden grid transition-all duration-450 ease-out-expo will-change-transform",
  variants: {
    expanded: {
      true: "grid-rows-[1fr]",
      false: "grid-rows-[0fr]",
    },
  },
});

export const expandingMenuContentInnerStyles = cva({
  base: "pb-20 flex flex-col gap-y-2",
});
